const production = {
  ASSET_ORIGIN: "https://cdn.navalabs.io",
  ASSET_MAP_PATH: "/garden/img_7HamWp",
  ASSET_MAP_PATH_ROOKIE: "/garden/img_7HamWr",
  SPLASH_PRO: "/assets/splash-pro-arena_4zCqWh.png",
  SPLASH_ROOKIE: "/assets/splash-rookie-island_4zCqWh.png",
  IS_TESTNET: false,
  IS_REFCODE_REQUIRED: false,
  PRIVY_APP_ID: "cm82t94ab02x7n3205bejpvy5",
  PRIVY_CLIENT_ID: undefined,
  RPC_URL: "https://marice-vytnsp-fast-mainnet.helius-rpc.com",
  API_BASE_URL: "https://v12-cfl-backend-production.up.railway.app",
  SHARE_PAGE_BASE_URL: "https://share.cfl.fun",
  PRICE_INGESTOR_URL: "https://price-ingestor-production.up.railway.app",
  FEE_RECIPIENT: "53uWfxz8FczDKpzWphdNMX5XycZJJ38vffL6EWUusDjW",
  POSTHOG: {
    HOST: "/cortex",
    KEY: "phc_uBVoYWa3sfgXNNt3LttrqBPdEQbIMqp1qmtEor1JHzE",
  },
  WORLD_MINI_APP: {
    // WARNING: CHANGE THIS WHEN GOING LIVE
    ID: "app_a131c09384e80f329db6e614d5070164" as `app_${string}`,
    VERIFY_ACTION: "verify-human",
  },
  ONESIGNAL_APP_ID: "7a6bbd12-9267-4f00-a29e-2da61bc2e8b8",
  SUPABASE_URL: "https://qpurukhqnrwjwytkcjre.supabase.co",
  SUPABASE_KEY:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFwdXJ1a2hxbnJ3and5dGtjanJlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY3MTgyMzQsImV4cCI6MjA2MjI5NDIzNH0.AoTAiSGjNXnw8Nruz6bq9Yse9rDs_U1FIY4nTIXUIls",
  TRITON_PYTHNET_API: "https://cfl-pythnet-2711.mainnet.pythnet.rpcpool.com",
  CONVEX_URL: "https://lovable-tapir-936.convex.cloud",
  CURRENT_SEASON: 2,
  USDC_MINT: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",

  GEO_BLOCK: {
    enabled: true,
    blockedCountries: ["US"],
  },

  //WARN: Enabling this will set the entire app inaccessible. Do not forget to toggle it back off
  MAINTENANCE: {
    enabled: true,
    message: undefined as string | undefined,
  },
};

export default production;
